import type { Crepe } from '@milkdown/crepe';
import { remarkStringifyOptionsCtx } from '@milkdown/kit/core';

/**
 * Canonical italic delimiters: `_text_`.
 * Schema default + stringify fallback read `remarkStringifyOptionsCtx.emphasis`.
 */
export function configureEmphasis(crepe: Crepe): void {
  crepe.editor.config((ctx) => {
    const prev = ctx.get(remarkStringifyOptionsCtx);
    ctx.set(remarkStringifyOptionsCtx, {
      ...prev,
      emphasis: '_',
    });
  });
}
